import { useTranslation } from "react-i18next";
import { Outlet, useLocation } from "react-router-dom";
import StaticSocialIcon from "./StaticSocialIcon";
import ProgressScroll from "./ProgressScroll";
import Footer from "./Footer";
import Navbar from "./Navbar";
import { useEffect } from "react";

const Layout = () => {
  const { i18n } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" }); // or "smooth"
  }, [location.pathname]);

  return (
    <div
      className={`${
        i18n.language === "ar" ? "font-alexandria" : "font-enriqueta"
      } relative bg-[#F2F6FA]`}
    >
      <Navbar />

      {/* Main content area */}
      <Outlet />

      <StaticSocialIcon />
      <ProgressScroll />
      <Footer />
    </div>
  );
};

export default Layout;
